<template>
  <a
    v-if="!isHide"
    class="banner-line"
    href="https://events.webinar.ru/59717051/446527885?utm_source=bimlib.pro&utm_campaign=webinar22062023"
    target="_blank"
    title="Подробнее"
  >
    <bim-container>
      <div class="bl-wrapper">
        <div class="bl-content">
          <span class="bl-content__icon" v-html="require('@/assets/img/man-book.svg')" />
          <div class="bl-content__text">Регистрация на вебинар
            <span style="font-weight: bold; white-space: nowrap">22 марта в 11:00 МСК</span>
          </div>
          <bim-button class="bl-content__btn" size="s" outline label="Подробнее" />
        </div>
        <div
          class="bl-close"
          v-html="require('@/assets/img/icon-close.svg')"
          title="Скрыть"
          @click.prevent="close"
        />
      </div>
    </bim-container>
  </a>
</template>

<script>
import bimContainer from '@/components/grid/bimContainer/bimContainer'
import bimButton from '@/components/form/bimButton/bimButton.vue'
import { usePrepareDate } from '@/utils/prepareDate'

const { setOffset } = usePrepareDate()
const key = 'top_banner_22_03'

export default {
  name: 'bimTopBannerLine',
  components: { bimContainer, bimButton },
  data: () => ({
    isClosed: 'hide'
  }),
  mounted () {
    if (typeof window !== 'undefined') {
      this.isClosed = sessionStorage.getItem(key)
    }
  },
  computed: {
    isHide () {
      const dateNow = setOffset(new Date()).getTime()
      // Wed Mar 22 2023 13:00:00 GMT+0000
      const dateEnd = setOffset(new Date(1679472000000)).getTime()
      return !!(this.isClosed || dateNow > dateEnd)
    }
  },
  methods: {
    close () {
      if (typeof window !== 'undefined') {
        sessionStorage.setItem(key, 'hide')
      }
      this.isClosed = 'hide'
    }
  }
}
</script>

<style scoped lang="scss">
.bl-content {
  display: flex;
  align-items: center;

  &__icon {
    margin-right: 10px;
    @media (max-width: 465px) {
      display: none;
    }
  }

  &__text {
    margin-right: 15px;
    white-space: break-spaces;
  }

  &__btn {
    @media (max-width: 405px) {
      display: none;
    }
  }
}

.bl-wrapper {
  display: flex;
  justify-content: center;
  min-height: 16px;
  position: relative;

  @media (max-width: 767px) {
    padding-right: 35px;
  }
}

.bl-close {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 0;
}

.banner-line {
  width: 100%;
  height: 48px;
  display: flex;
  color: #232323;
  align-items: center;
  text-decoration: none;
  background-color: #F4FBFA;
}
</style>
